import React from "react";

export default props => (
<div className="test-page-content-inner test-page-start">
    <img src="/images/Logo.png" alt="CPP logo" />
    <h1>Let's get started!</h1>
</div>
);
